export function QKeyBoardInfo() {
  this.keyCode = null;
  this.charCode = null;
  this.ctrlKey = false;
  this.shiftKey = false;
  this.altKey = false;
  this.ignoreEvent = false;
  this.funcKey = false;
  this.source = null;
  this.metaKey = false;
}
